import BaseService from './../../base'

class DanceService extends BaseService {
  // 新增舞蹈
  async createDanceApi (postData) {
    return await this.post('/api/v2/admin/dance', postData);
  }

  // 删除舞蹈
  async deleteDanceApi (id) {
    return await this.delete(`/api/v2/admin/dance/${id}`);
  }

  async updateDanceApi (id, postData) {
    return await this.put(`/api/v2/admin/dance/${id}`, postData);
  }

  async danceListApi (queryParams) {
    return await this.get('/api/v2/admin/dance', queryParams);
  }
}

export default new DanceService()
